
// This is the store

// Locale
// import locale from './locale'

// Firebase
import firebase from './firebase'
firebase

var store = {
  rootRef: 'members/users/',
  showDialog: false,
  admin: false,
  uid: '',
  user: {},
  members: {}
}

export default store



// WEBPACK FOOTER //
// ./src/modules/store.js